import { Injectable } from '@angular/core';
import { GqlQueryBuilderService } from '../standalone-packages/ecap3/core';
import gql from 'graphql-tag';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { EcapGql } from '../standalone-packages/ecap3/app-platform-graphql';

@Injectable({
    providedIn: 'root'
})
export class GraphqlService {
    constructor(
        private GQL: EcapGql,
        private gqlQueryBuilderService: GqlQueryBuilderService // private utilityService: UtilityService, // private aggregateService: AggregateService,
    ) {}

    executeQuery(query): Observable<any> {
        return this.GQL.watchQuery<any>({
            query: query,
            errorPolicy: 'all'
        }).valueChanges.pipe(
            map(result => {
                if (result) {
                    return result;
                }
                return result;
            })
        );
    }
    prepareQueryBasicForAggregation(
        entityName: string,
        fields: any,
        filters: string,
        orderBy?: any,
        pageNumber: number = 0,
        pageSize: number = 100
    ) {
        return ` ${this.buildQueryBasic({
            entityName,
            fields,
            filters,
            orderBy,
            pageNumber,
            pageSize
        })}`;
    }

    buildQueryBasic(config) {
        return `
            ${config.entityName}s(
            Model:{
             ${config.pageNumber ? `PageNumber: ${config.pageNumber},` : ''}
             Filter: "{ ${config.filters} }"
             ${config.orderBy ? `Sort: "{${config.orderBy}}",` : ''} 
             ${config.pageSize ? `PageSize: ${config.pageSize},` : ''}
            }){
              Data{
                ${config.fields.join(',')}
              },
              ErrorMessage,
              Success,
              ValidationResult,
              TotalCount
            }
        `;
    }

    prepareEventGql(eventName, eventData) {
        return `EventName: "${eventName}",EventData: ${JSON.stringify(JSON.stringify(eventData))}`;
    }
    prepareInsertModelWithEvent(entityName: string, model: any, event) {
        return gql`
            mutation create{
                ${this.buildInsertQueryWithModel({ entityName, model, event })}
            }
        `;
    }
    buildInsertQueryWithModel(config) {
        const modelString = this.gqlQueryBuilderService.convertObjectToGQLString(config.model);
        return `
            ${config.entityName}(
				Model: ${modelString}, 
				${config.event}	
				MutationType: INSERT
            ) {
            ErrorMessage
            Result
            Success
            ValidationResult
            }
        `;
    }

    getDataByGql(
        entityName: string,
        fields: any,
        filterQuery?: any,
        sort?: string,
        pageNumber?: number,
        pageSize?: number
    ): Observable<any> {
        return this.GQL.watchQuery<any>({
            query: this.gqlQueryBuilderService.prepareQuery(
                entityName,
                fields,
                filterQuery,
                sort,
                pageNumber,
                pageSize
            ),
            errorPolicy: 'all'
        }).valueChanges.pipe(
            map((result: any) => {
                // console.error('00000',result.errors ? result.errors[0].message : '');
                if (result) {
                    return result;
                }
                return result;
            })
        );
    }
    getDateFilterForParticularRange(startDate, endDate) {
        return `{$lt: ISODate('${endDate}'),$gte: ISODate('${startDate}')}`;
    }

    getFiltersForArrayOfObject(listOfArray, property, key) {
        const filter = [];
        listOfArray &&
            listOfArray.forEach(value => {
                filter.push(`'${value[key]}'`);
            });
        const query = `${property}:{$in:[${filter.join(',')}]}`;
        return query;
    }

    getFiltersForArray(listOfArray, property) {
        const filter = [];
        listOfArray &&
            listOfArray.forEach(value => {
                filter.push(`'${value}'`);
            });
        const query = `${property}:{$in:[${filter.join(',')}]}`;
        return query;
    }

    prepareFilterFromOperator(expressionArray: any[]) {
        const filters = [];
        expressionArray.forEach(expression => {
            console.warn(expression);
            filters.push(this[expression.operator](expression.value));
        });
        console.warn(filters);

        return filters;
    }
    buildDistinctQuery(
        name,
        entityName: string,
        filter: string,
        group: string,
        pageNumber = 0,
        pageSize = 100,
        sort?: string,
        unwind?: string
    ) {
        return `${name}(
            Model:{
                EntityName: "${entityName}",
                PageNumber: ${pageNumber + 1},
                PageSize: ${pageSize},
                ${filter ? `Filter: "${filter}",` : ''}
                ${unwind ? `Unwind: "${unwind}",` : ''}
                Group: "${group}"
                ${sort ? `, Sort: "${sort}"` : ''}
            }){
             Data,
             ErrorMessage,
             Success,
             ValidationResult,
             TotalCount
           }`;
    }
    queryDistinctData(entityName: string, filter, group, page = 0, size = 1000, sort?, unwind?): Observable<any> {
        return this.GQL.watchQuery<any>({
            query: this.gqlQueryBuilderService.prepareDistinctQuery(
                entityName,
                filter,
                group,
                page,
                size,
                sort,
                unwind
            ),
            errorPolicy: 'all'
        }).valueChanges.pipe(
            map((response: any) => {
                if (response.data && response.data.AggregateQuery && response.data.AggregateQuery.Data.length) {
                    return response.data.AggregateQuery;
                }
                return { Data: [], TotalCount: 0 };
            })
        );
    }

    __and(values: any, stringReturn?: boolean) {
        const filterObj: any = {
            operator: 'raw',
            value: ''
        };
        let queryString = '';
        values.forEach((value, index) => {
            const paramsValue = ['string', 'boolean', 'number'].includes(typeof value.value) ? value : value.value;
            if (values.length - 1 !== index) {
                queryString += `{${this[value.operator](paramsValue, true)}},`;
            } else {
                queryString += `{${this[value.operator](paramsValue, true)}}`;
            }
        });
        if (stringReturn) {
            return `$and:[ ${queryString} ]`;
        }
        filterObj.value += `$and:[ ${queryString} ]`;
        return filterObj;
    }
    __search(expression: any, stringReturn?: boolean) {
        if (stringReturn) {
            return `${expression.propertyName}: /${expression.value}/i`;
        } else {
            return {
                operator: 'raw',
                value: `${expression.propertyName}: /${expression.value}/i`
            };
        }
    }
    __or(values: any, stringReturn?: boolean) {
        const filterObj: any = {
            operator: 'raw',
            value: ''
        };
        let queryString = '';
        values.forEach((value, index) => {
            const paramsValue = ['string', 'boolean'].includes(typeof value.value) ? value : value.value;
            if (values.length - 1 !== index) {
                queryString += `{${this[value.operator](paramsValue, true)}},`;
            } else {
                queryString += `{${this[value.operator](paramsValue, true)}}`;
            }
        });
        if (stringReturn) {
            return `$or:[ ${queryString} ]`;
        }
        filterObj.value += `$or:[ ${queryString} ]`;
        return filterObj;
    }
    __contains(expression: any, stringReturn?: boolean) {
        if (stringReturn) {
            return `${expression.propertyName}: { $in: ${expression.value} }`;
        } else {
            return {
                operator: 'raw',
                value: `${expression.propertyName}: { $in: ${expression.value}}`
            };
        }
    }
    __notContains(expression: any, stringReturn?: boolean) {
        if (stringReturn) {
            return `${expression.propertyName}: { $nin: ${expression.value}}`;
        } else {
            return {
                operator: 'raw',
                value: `${expression.propertyName}: { $nin: ${expression.value}}`
            };
        }
    }
    __range(expression, stringReturn?: boolean) {
        if (stringReturn) {
            return `${expression.propertyName}: { $gte: ${expression.value.startValue}, $lte: ${expression.value.endValue}}`;
        } else {
            return {
                operator: 'raw',
                value: `${expression.propertyName}: { $gte: ${expression.value.startValue}, $lte: ${expression.value.endValue}}`
            };
        }
    }
    __greaterThanOrEqualAndLessThanOrEqual(expression: any, stringReturn?: boolean) {
        if (stringReturn) {
            const parsedValue = expression.value.replace(/\[|\]/gi, '').split(',');
            return `${expression.propertyName}: { $gte: ${parsedValue[0]}, $lte: ${parsedValue[1]}}`;
        } else {
            const parsedValue = expression.value.replace(/\[|\]/gi, '').split(',');
            return {
                operator: 'raw',
                value: `${expression.propertyName}: { $gte: ${parsedValue[0]}, $lte: ${parsedValue[1]}}`
            };
        }
    }
    __equal(expression: any, stringReturn?: boolean) {
        if (stringReturn) {
            return `${expression.propertyName}: ${expression.value}`;
        } else {
            return {
                operator: 'raw',
                value: `${expression.propertyName}: ${expression.value}`
            };
        }
    }
    __notEqual(expression: any, stringReturn?: boolean) {
        if (stringReturn) {
            return `${expression.propertyName}: { $ne : ${expression.value}}`;
        } else {
            return {
                operator: 'raw',
                value: `${expression.propertyName}: { $ne : ${expression.value}}`
            };
        }
    }
    __equalISODate(expression: any, stringReturn?: boolean) {
        if (stringReturn) {
            return `${expression.propertyName}: ISODate('${expression.value}')`;
        } else {
            return {
                operator: 'raw',
                value: `${expression.propertyName}: ISODate('${expression.value}')`
            };
        }
    }
}
